<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['patient_appointments']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex justify-content-between">
              <div><b-button v-b-modal.new-appointment size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Appointment</b-button></div>
              <export-excel class = "btn btn-sm btn-primary mb-2" :data = Items name = "APPOINTMENTS.xls"> Export <i class="mdi mdi-download"></i></export-excel>
          </div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(patient)="data">
                {{ data.item.patient.name }}
              </template>
              <template #cell(patientid)="data">
                {{ data.item.patient.patient_id }}
              </template>
              <template #cell(patientct)="data">
                +256 {{ data.item.patient.telephone }}
              </template>
              <template #cell(staff)="data">
                {{ data.item.staff.full_name }}
              </template>
              <template #cell(appointment_date)="data">
                {{ data.item.appointment_date }} {{ data.item.appointment_time }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.patient.patient_id,data.item.staff.id,data.item.appointment_date,data.item.appointment_time )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.patient.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Appointments</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-appointment" centered title="New Appointment" title-class="font-18" hide-footer>
        <form @submit.prevent="addAppointment">
          <div class="form-group mb-2">
            <label>Patient's Name</label>
              <multiselect v-model="patient" :options="patients" :custom-label="customLabel" label="name"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Person to See</label>
            <multiselect v-model="staff" :options="users" label="username"></multiselect>
            </div>
            <div class="form-group mb-2">
            <label>Appointment Date</label>
            <input v-model="appointmentdate" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Appointment Time</label>
            <input v-model="appointmenttime" type="time" required class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-appointment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-appointment" centered title="Edit Appointment" title-class="font-14" hide-footer>
        <form @submit.prevent="editAppointment">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Patient</label>
            <b-form-select v-model="patient" required :options="patients" class="mb-3 form-control" value-field="patient_id" text-field="name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Person to See</label>
            <b-form-select v-model="staff" required :options="users" class="mb-3 form-control" value-field="id" text-field="full_name"></b-form-select>
            </div>
            <div class="form-group mb-2">
            <label>Appointment Date</label>
            <input v-model="appointmentdate" type="date" required class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Appointment Time</label>
            <input v-model="appointmenttime" type="time" required class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-appointment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-appointment" centered title="Delete Appointment " title-class="font-18" hide-footer>
        <form @submit.prevent="removeAppointment">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Appointment for : <b>{{ patient }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-appointment')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import Multiselect from "vue-multiselect";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { userMethods , patientMethods,appointmentMethods, appointmentComputed,userComputed, patientComputed } from "@/state/helpers";

export default {
  page: {
    title: "Patient Appointments",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Multiselect,Layout,PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Patient Appointments",
      items: [ {text: "Dashboard",to: "/",}, {text: "Patient Appointments",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'patientid', label: 'Patient ID', visible: true },
          { key: 'patient', label: 'Patient Name', visible: true },
          { key: 'patientct', label: 'Patient Contact', visible: true },
          { key: 'staff', label: 'Person to See', visible: true },
          { key: 'appointment_date', label: 'Appointment Date', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      patient:'',
      staff:'',
      appointmentdate:new Date().toLocaleDateString('fr-CA'),
      appointmenttime:'',
    };
  },
  computed: {
    ...appointmentComputed,
    ...userComputed,
    ...patientComputed,
    List() { return this.appointments.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.appointments.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.appointments.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchAppointments();
    this.fetchPatients();
    this.fetchUsers();
    this.TotalRows = this.appointments.length;
    this.isBusy=false;
  },
  methods: {
    ...appointmentMethods,
    ...patientMethods,
    ...userMethods,

    customLabel ({ patient_id, name, telephone }) {
      return `${patient_id} – ${name} – ${telephone}`
    },
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,patient,staff,appointmentdate,appointmenttime){
      this.id=id;
      this.patient=patient;
      this.appointmentdate=appointmentdate;
      this.staff=staff;
      this.appointmenttime=appointmenttime;
      this.$bvModal.show('edit-appointment')
    },
    remove(id,patient){
      this.id=id;
      this.patient=patient;
      this.$bvModal.show('delete-appointment')
    },
    async addAppointment() { 
      let formData = new FormData();
      formData.append("patient", this.patient.patient_id);
      formData.append("appointmentdate", this.appointmentdate);
      formData.append("staff", this.staff.id);
      formData.append("appointmenttime", this.appointmenttime);
      let url = "/addappointment";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchAppointments();
          this.$bvModal.hide('new-appointment');
          this.patient="";
          this.appointmentdate="";
          this.staff="";
          this.appointmenttime="";
          this.$toast.success("New Patient Appointment Added");
      }
      });
    },
    async editAppointment(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("patient", this.patient);
    formData.append("appointmentdate", this.appointmentdate);
    formData.append("staff", this.staff);
    formData.append("appointmenttime", this.appointmenttime);
    let url = "/updateappointment";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchAppointments();
        this.$bvModal.hide('edit-appointment');
        this.patient="";
          this.appointmentdate="";
          this.staff="";
          this.appointmenttime="";
          this.$toast.success("Patient Appointment Updated");
      }
    });
    },
    async removeAppointment() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeappointment";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchAppointments();
        this.$bvModal.hide('delete-appointment');
        this.$toast.error("Patient Appointment Deleted");
      }
    });
    },
  },
};
</script>